import React from 'react';
import { usePageSeo } from '../hooks/usePageSeo';
import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';

const WebsiteTOS = () => {
  usePageSeo({
    title: 'Website Terms of Service | Civic Rentals LLC',
    description: 'Civic Rentals LLC website terms and conditions governing access to and use of civicrentals.com.',
    canonical: 'https://civicrentals.com/websiteTOS',
    ogTitle: 'Website Terms of Service | Civic Rentals LLC',
    ogDescription: 'Civic Rentals LLC website terms and conditions governing access to and use of civicrentals.com.',
    ogUrl: 'https://civicrentals.com/websiteTOS',
    ogImage: 'https://civicrentals.com/favicon.png',
    twitterCard: 'summary',
  });

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#d5e0de' }}>
      <Header />

      <section className="pt-32 pb-16 px-6">
        <div className="container mx-auto max-w-3xl">
          {/* Breadcrumbs */}
          <nav aria-label="Breadcrumb" className="mb-6" data-testid="breadcrumbs">
            <ol className="flex items-center gap-1.5 text-sm text-slate-500">
              <li><Link to="/" className="hover:text-slate-800 transition-colors">Home</Link></li>
              <li><ChevronRight className="h-3.5 w-3.5" /></li>
              <li className="text-slate-700 font-medium">Terms of Service</li>
            </ol>
          </nav>

          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
            <div className="px-8 py-8 sm:px-10 sm:py-10">
              <h1 className="text-3xl font-bold text-slate-900 mb-4" data-testid="tos-title">CIVIC RENTALS LLC WEBSITE TERMS AND CONDITIONS</h1>
              <p className="text-sm text-slate-500 mb-8">Last updated: August 29, 2026</p>

              <p className="text-slate-700 leading-relaxed mb-4">
                These Terms and Conditions ("Terms") govern your access to and use of civicrentals.com (the "Site"). By accessing or using the Site, you agree to these Terms. If you do not agree to these Terms, do not use the Site.
              </p>
            </div>
          </div>
        </div>
      </section>

      <footer className="bg-slate-900 text-slate-400 py-12 px-6 border-t border-slate-800">
        <div className="container mx-auto max-w-6xl">
          <div className="border-t border-slate-800 pt-8 text-center text-sm">
            <p>&copy; 2026 Civic Rentals LLC. All rights reserved.</p>
            <p className="mt-2 space-x-4">
              <Link to="/privacypolicy" className="hover:text-white transition-colors">Privacy Policy</Link>
              <Link to="/websiteTOS" className="hover:text-white transition-colors">Terms of Service</Link>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default WebsiteTOS;
